// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import underscore from 'vue-underscore'
import VueMoment from 'vue-moment'
import VueStash from 'vue-stash'
// import visibility from 'vue-visibility-change'
import VueAnalytics from 'vue-analytics'
import VueObserveVisibility from 'vue-observe-visibility'

import App from './App'
import router from './router'

Vue.use(VueAxios, axios)
Vue.use(underscore)
Vue.use(VueMoment)
// Vue.use(visibility)
Vue.use(VueObserveVisibility)
Vue.use(VueAnalytics, {
  id: 'UA-117755947-1',
  router,
  set: [
    { field: 'anonymizeIp', value: true }
  ]
})

Vue.use(VueStash)

Vue.config.productionTip = false

// Global Axios Settings
axios.defaults.baseURL = 'http://localhost:3245/api/'
if (process.env.NODE_ENV === 'production') axios.defaults.baseURL = 'https://gootics.com/api/'
if (process.env.NODE_ENV === 'staging') axios.defaults.baseURL = 'https://keylogs.staging.webmarken.com/api/'

axios.defaults.headers.get['Auth'] = localStorage.getItem('token') // for POST requests
axios.defaults.headers.post['Auth'] = localStorage.getItem('token')
axios.defaults.headers.delete['Auth'] = localStorage.getItem('token')
axios.defaults.headers.put['Auth'] = localStorage.getItem('token')

axios.interceptors.response.use(response => { // intercept the global error
  return response
}, function (error) {
  let originalRequest = error.config
  console.log(error, error.response.status)
  // if the error is 401 and Auth String is present (so this does not triggered when still logged out)
  if (error.response.status === 401 && typeof originalRequest.headers.Auth === 'string') {
    console.log('user unauthorized - log out')
    localStorage.removeItem('token')
    localStorage.removeItem('subscription')
    localStorage.removeItem('user')
    router.replace('/login')
  }
  // Do something with response error
  return Promise.reject(error)
})

router.beforeEach((to, from, next) => {
  // reroute if not authenticated
  if (to.name === 'Login' || to.name === 'LoginEx' || to.name === 'Privacy' || to.name === 'TaC') next()
  else {
    try {
      var token = localStorage.getItem('token')
      // TODO: Better?
      if (token && token !== '') {
        next()
      } else {
        next({ path: '/login' })
      }
    } catch (e) {
      console.log(e)
      next({ path: '/login' })
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    store: {
      colorMode: 'lightmode'
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js